(() => {
  if (customElements.get('sissilux-faq')) return;
  class SissiluxFaq extends HTMLElement {
    connectedCallback() {
      if (this._events) return;
      this._events = new AbortController();
      const signal = this._events.signal;
      this.rows = Array.from(this.querySelectorAll('.siss-faq__list > .siss-faq__item'));
      this.limit = Math.max(6, Math.min(8, Number(this.dataset.initialCount) || 6));
      this.expanded = false;
      this.more = this.querySelector('.siss-faq__more');
      this.footer = this.querySelector('.siss-faq__footer');
      if (!this.more || !this.footer) return;
      this.more.addEventListener('click', () => {
        this.expanded = !this.expanded;
        this.render();
        if (!this.expanded) {
          this.more.focus({ preventScroll: true });
          const rect = this.more.getBoundingClientRect();
          if (rect.top < 0 || rect.bottom > window.innerHeight) this.more.scrollIntoView({ block: 'nearest', behavior: 'instant' });
        }
      }, { signal });
      this.rows.forEach(row => row.addEventListener('toggle', () => {
        row.querySelector('summary').setAttribute('aria-expanded', String(row.open));
      }, { signal }));
      this.addEventListener('shopify:block:select', event => {
        const row = event.target.closest('.siss-faq__item');
        if (!row || !this.contains(row)) return;
        if (this.rows.indexOf(row) >= this.limit) this.expanded = true;
        this.render();
        row.open = true;
      }, { signal });
      this.render();
    }
    render() {
      this.rows.forEach((row, index) => {
        row.hidden = !this.expanded && index >= this.limit;
        row.querySelector('summary').setAttribute('aria-expanded', String(row.open));
      });
      const hasMore = this.rows.length > this.limit;
      this.footer.hidden = !hasMore;
      this.more.setAttribute('aria-expanded', String(this.expanded));
      this.more.querySelector('span').textContent = this.expanded ? this.dataset.lessLabel : `${this.dataset.moreLabel} (${Math.max(0, this.rows.length - this.limit)})`;
    }
    disconnectedCallback() {
      this._events?.abort();
      this._events = null;
    }
  }
  customElements.define('sissilux-faq', SissiluxFaq);
})();
